import {
  TaskTrackerAutomationColumnOption,
  TaskTrackerBoardAutomation,
  TaskTrackerBoardAutomationAction,
  TaskTrackerBoardAutomationsDetails,
} from '../store/taskTracker.types'
import {
  ApiTaskTrackerAutomation,
  ApiTaskTrackerAutomationAction,
  ApiTaskTrackerAutomationColumn,
  ApiTaskTrackerAutomationsIndexResponse,
} from './taskTracker.api.types'
import { mapBoardFromApi } from './taskTracker.boards.api.mappers'

export const mapAutomationActionFromApi = (
  item: ApiTaskTrackerAutomationAction,
): TaskTrackerBoardAutomationAction => ({
  id: Number(item.id),
  automationId: Number(item.automation_id),
  actionType: String(item.action_type ?? '').trim(),
  params:
    item.params && typeof item.params === 'object' && !Array.isArray(item.params)
      ? item.params
      : {},
  sorting: Number(item.sorting ?? 0),
})

export const mapAutomationFromApi = (
  item: ApiTaskTrackerAutomation,
): TaskTrackerBoardAutomation => ({
  id: Number(item.id),
  boardId: Number(item.board_id),
  title: String(item.title ?? '').trim(),
  triggerEvent: String(item.trigger_event ?? '').trim(),
  isActive: Boolean(item.is_active),
  actions: (item.actions ?? []).map(mapAutomationActionFromApi),
})

export const mapAutomationColumnFromApi = (
  item: ApiTaskTrackerAutomationColumn,
): TaskTrackerAutomationColumnOption => ({
  id: Number(item.id),
  boardId: Number(item.board_id),
  title: String(item.title ?? '').trim(),
  color: String(item.color ?? '').trim(),
  position: Number(item.position ?? 0),
})

export const mapAutomationsDetailsFromApi = (
  item: ApiTaskTrackerAutomationsIndexResponse,
): TaskTrackerBoardAutomationsDetails => ({
  board: mapBoardFromApi(item.board),
  automations: (item.automations ?? []).map(mapAutomationFromApi),
  availableColumns: (item.available_columns ?? [])
    .map(mapAutomationColumnFromApi)
    .sort((a, b) => a.position - b.position || a.id - b.id),
  supportedTriggerEvents: item.supported_trigger_events ?? {},
  supportedActionTypes: item.supported_action_types ?? {},
})
